import React from "react";
import JobApplicationForm from "./JobApplicationForm";
import { useLocation, useNavigate } from "react-router-dom";
import {
    FaArrowLeft,
    FaMoneyBillWave,
    FaMapMarkerAlt,
    FaClock
} from "react-icons/fa";
import { MdWork } from "react-icons/md";
import "./JobDetailPage.css";

const JobDetailPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { job } = location.state || {};

    if (!job) {
        return <div className="job-detail-container">Job not found.</div>;
    }

  return (
    <div>
        <section className="section-aboutasg">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">JOB DETAILS</h2>
      <div className="sectionbottom-line"></div>
      </section>
        <div className="job-detail-wrapper">
               
            <div className="job-detail-container">
            <button className="back-button" onClick={() => navigate(-1)}>
                <FaArrowLeft /> Back to results
            </button>

            <div className="job-header">
                <h1>{job.title}</h1>
                <p className="job-id">{job.id}</p>
                <p className="posted-date"><strong>Posted:</strong> {job.postedDate}</p>
                <div className="job-meta">
                    <span><FaMoneyBillWave /> {job.salary}</span>
                    <span><FaMapMarkerAlt /> {job.location}</span>
                    <span><FaClock /> {job.jobType}</span>
                    <span><MdWork /> {job.specialism}</span>
                </div>
            </div>

            <div className="job-body">
                <p className="job-summary">{job.summary}</p>
                <h3>Your responsibilities will include:</h3>
                <ul>
                {job.responsibilities?.map((item, index) => (
                    <li key={index}>
                    ➤ {typeof item === "string" ? item : item.main}
                    {Array.isArray(item.sub) && (
                        <ul className="sub-bullet">
                        {item.sub.map((subItem, subIndex) => (
                            <li key={subIndex}>– {subItem}</li>
                        ))}
                        </ul>
                    )}
                    </li>
                )) || <li>Details coming soon.</li>}
                </ul>

                <h3>The successful candidate:</h3>
                <ul>
                {job.requirements?.map((item, index) => (
                    <li key={index}>
                    ➤ {typeof item === "string" ? item : item.main}
                    {Array.isArray(item.sub) && (
                        <ul className="sub-bullet">
                        {item.sub.map((subItem, subIndex) => (
                            <li key={subIndex}>– {subItem}</li>
                        ))}
                        </ul>
                    )}
                    </li>
                )) || <li>Details coming soon.</li>}
                </ul>


            </div>
        </div>
        
        <div className="job-form-container">
            <JobApplicationForm />
        </div>
    </div>
    </div>
  );
};

export default JobDetailPage;
